<template>
  <b-card>
    <template #header>
      <div class="d-flex">
        <h4 class="mb-0">Benefícios por Emendas Parlamentares</h4>
        <div class="ml-auto">
          <b-button
            v-b-toggle="'collapse-beneficios-emendas'"
            size="sm"
            class="mr-1 border-0"
            variant="outline-secondary"
          >
            <span class="when-open"><font-awesome-icon icon="eye" /></span>
            <span class="when-closed"
              ><font-awesome-icon icon="eye-slash"
            /></span>
          </b-button>
        </div>
      </div>
    </template>

    <b-collapse id="collapse-beneficios-emendas" visible>
      <div class="d-flex mb-2">
        <div class="w-50">
          <b-input-group size="sm">
            <b-form-input
              v-model="search"
              placeholder="Pesquisar"
              @keypress.enter="loadData"
            ></b-form-input>
          </b-input-group>
        </div>
        <div class="ml-auto">
          <b-button size="sm" variant="exitos" @click="addEmenda()">
            <font-awesome-icon icon="plus" />
            Adicionar Emenda
          </b-button>
        </div>
      </div>

      <b-table
        responsive
        striped
        hover
        show-empty
        :items="emendas"
        :fields="fields"
      >
        <template #cell(cnpj)="{ item }">
          {{ item.cnpj | cnpj }}
          <small class="text-muted d-block">{{ item.beneficiario }}</small>
        </template>
        <template #cell(municipio)="{ item }">
          <span v-if="item.municipio">
            {{ item.municipio.nome }}
            <small class="text-muted d-block">{{
              item.municipio.sigla_estado
            }}</small>
          </span>
        </template>
        <template #cell(repasse)="{ item }">
          {{ item.repasse | number_format }}
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :edit_to="null"
            @edit="addEmenda(row.item)"
            @delete="deleteEmenda(row.item)"
          />
        </template>
        <template #empty="{}">
          <h5 class="text-center">Nenhum item cadastrado</h5>
        </template>
      </b-table>

      <div>
        <pagination-nav :pagination="pagination" @input="loadData()" />
      </div>
    </b-collapse>

    <Estatisticas :valores="oportunidade_estatisticas.emendas" />

    <b-modal
      title="Dados da Emenda"
      id="modal-emenda"
      ref="modal-emenda"
      size="lg"
      ok-variant="exitos"
      @ok="saveEmenda"
      @hidden="resetEdit"
    >
      <form-emendas :value="emenda_edit" ref="form-emenda" />
    </b-modal>
  </b-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Actions from "@/components/Table/Actions.vue";
import draggable from "vuedraggable";
import FormEmendas from "./FormEmendas.vue";
import Estatisticas from "./Estatisticas.vue";

export default {
  components: { Actions, draggable, FormEmendas, Estatisticas },
  data: () => ({
    emendas: [],
    emenda_index: null,
    emenda_edit: null,
    pagination: {
      currentPage: 1,
      perPage: 10,
      total: 0,
    },
    search: "",
  }),
  computed: {
    ...mapState("oportunidades", ["oportunidade", "oportunidade_estatisticas"]),
    fields() {
      return [
        { key: "emenda", label: "Nº Emenda", sortable: true, class: "col-2" },
        {
          key: "parlamentar",
          label: "Parlamentar",
          sortable: true,
        },
        {
          key: "cnpj",
          label: "CNPJ",
          sortable: true,
          class: "col-3",
        },
        {
          key: "repasse",
          label: "Repasse",
          sortable: true,
          class: "col-2",
        },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("oportunidades", [
      "ActionGetAllEmendas",
      "ActionSaveEmenda",
      "ActionDeleteEmenda",
    ]),
    addEmenda(item = null) {
      if (item !== null) {
        this.emenda_edit = item;
      } else {
        this.emenda_edit = null;
      }
      this.$bvModal.show("modal-emenda");
    },
    async deleteEmenda(emenda) {
      try {
        await this.ActionDeleteEmenda(emenda.id);
        this.$notifications.addNotification({
          message: "Emenda excluída com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (err) {
        this.$notifications.addNotification({
          message: "Erro ao excluir emenda benefício",
          type: "danger",
        });
      }
    },
    async saveEmenda(evt) {
      evt.preventDefault();
      let emenda = await this.$refs["form-emenda"].save();
      emenda.oportunidade_id = this.oportunidade.id;

      try {
        await this.ActionSaveEmenda(emenda);
        this.$notifications.addNotification({
          message: "Dados salvos com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (err) {
        this.$notifications.addNotification({
          message: "Erro ao salvar benefício",
          type: "danger",
        });
      }

      this.$nextTick(() => {
        this.$bvModal.hide("modal-emenda");
      });
    },
    async loadData(evt) {
      if (evt) {
        evt.preventDefault();
      }
      let response = await this.ActionGetAllEmendas({
        page: this.pagination.current_page,
        per_page: this.pagination.per_page,
        orderBy: this.sortBy,
        sortBy: this.sortDesc ? "desc" : "asc",
        q: this.search,
        oportunidade_id: this.oportunidade.id,
      });
      this.emendas = response.data;
      this.pagination = response.meta;
    },
    resetEdit() {
      this.emenda_index = null;
      this.emenda_edit = null;
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="scss">
.list-beneficios {
  .handle {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }

  .td-item {
    padding-top: 0.3rem;
    padding-bottom: 0;
  }
}
</style>
